import { FETCH_CREDITS } from '../actions/types'

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_CREDITS:
      return {
        ...state,
        [action.payload.userId]: {
          ...state[action.payload.userId],
          [action.payload.portalId]: action.payload.data
        }
      }
    default:
      return state
  }
}
